import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _CloseIcon, _CloudTwoToneIcon;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
/* eslint-disable max-lines */
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import CloudTwoToneIcon from '@mui/icons-material/CloudTwoTone';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import { delay, setDigitalData } from '../utils';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { styled } from '@mui/material/styles';
import { useTranslate } from '@im/react-localization';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SearchTypeAhead(props) {
  var testid = props['data-testid'],
    _props$enableAISugges = props.enableAISuggestions,
    enableAISuggestions = _props$enableAISugges === void 0 ? false : _props$enableAISugges,
    getSearchSuggestions = props.getSearchSuggestions,
    onSearch = props.onSearch;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 1),
    selectedCategories = _useState2[0];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    term = _useState4[0],
    setTerm = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    suggestions = _useState6[0],
    setSuggestions = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    inputValue = _useState8[0],
    setInputValue = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    mouseInListBox = _useState10[0],
    setMouseInListBox = _useState10[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var location = useLocation();
  var translate = useTranslate();
  var onChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event, value) {
      var queryParam, isCloud, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof value === 'string')) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            queryParam = 'keywords';
            isCloud = value.source === 'subscriptionplantitle' || value.source === 'subscriptiongrouptitle' || value.source === 'cattitle';
            _context.t0 = value.type;
            _context.next = _context.t0 === 'Products' ? 7 : _context.t0 === 'Resources' ? 7 : _context.t0 === 'Vendors' ? 9 : _context.t0 === 'Categories' ? 11 : _context.t0 === 'SubCategories' ? 13 : 15;
            break;
          case 7:
            queryParam = 'keywords';
            return _context.abrupt("break", 15);
          case 9:
            queryParam = 'vendor';
            return _context.abrupt("break", 15);
          case 11:
            queryParam = 'category';
            return _context.abrupt("break", 15);
          case 13:
            queryParam = 'subcategory';
            return _context.abrupt("break", 15);
          case 15:
            setInputValue(value.option);
            _context.next = 18;
            return onSearch({
              searchType: queryParam,
              selectedCategories: selectedCategories,
              source: value.source,
              text: value.option
            });
          case 18:
            res = _context.sent;
            if (res) {
              setDigiData(!isCloud ? 'keyword suggestion' : 'cloud subscription suggestion', value.option, queryParam);
            }
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onChange(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var onInputChange = function onInputChange(event, text, reason) {
    if (reason === 'input') {
      setInputValue(text);
      setTerm(text.trimStart());
    }
  };
  var onKeyPress = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(event.key === 'Enter')) {
              _context2.next = 7;
              break;
            }
            if (!term) {
              _context2.next = 6;
              break;
            }
            _context2.next = 4;
            return onSearch({
              searchType: 'keywords',
              selectedCategories: selectedCategories,
              text: term
            });
          case 4:
            res = _context2.sent;
            if (res) {
              setDigiData('Enter', term, 'keyword');
            }
          case 6:
            event.preventDefault();
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onKeyPress(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSearch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(triggeredBy) {
      var res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!term) {
              _context3.next = 5;
              break;
            }
            _context3.next = 3;
            return onSearch({
              searchType: 'keywords',
              selectedCategories: selectedCategories,
              text: term
            });
          case 3:
            res = _context3.sent;
            if (res) {
              setDigiData(triggeredBy, term, 'keyword');
            }
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleSearch(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    setInputValue('');
    setTerm('');
  };
  var setDigiData = function setDigiData(submit, term, type) {
    setTimeout(function () {
      setDigitalData({
        internalSearch: {
          searchReferrerPage: location == null ? void 0 : location.pathname,
          searchSubmit: submit,
          searchTerm: term,
          searchType: type
        }
      });
    }, 2000);
  };
  useEffect(function () {
    var _searchParams$get, _searchParams$get2, _searchParams$get3;
    var keywords = (_searchParams$get = searchParams.get('keywords')) != null ? _searchParams$get : '';
    var title = (_searchParams$get2 = searchParams.get('title')) != null ? _searchParams$get2 : '';
    var displaytitle = (_searchParams$get3 = searchParams.get('displaytitle')) != null ? _searchParams$get3 : '';
    if (location.pathname === '/product/productsearch' || location.pathname === '/product/associateproductsearch') {
      var inpVal = title && title !== '' ? '' : displaytitle || '';
      setInputValue(inpVal);
      setTerm(inpVal);
    } else if (keywords !== '') {
      setInputValue(keywords);
    } else {
      setInputValue('');
      setTerm('');
    }
  }, [location.pathname, searchParams]);
  useEffect(function () {
    var active = true;
    if (!term) {
      setSuggestions([]);
    } else {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var response, reformatedSuggestions;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return delay(300);
            case 2:
              if (active) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _context4.next = 6;
              return getSearchSuggestions(term);
            case 6:
              response = _context4.sent;
              if (active) {
                reformatedSuggestions = response.reduce(function (accu, row) {
                  var suggestionRows = [];
                  // eslint-disable-next-line array-callback-return
                  row.suggestions.map(function (suggestion) {
                    if (typeof suggestion !== 'string') {
                      return suggestionRows.push({
                        isCloud: suggestion.isCloudSuggestion,
                        option: suggestion.suggestion,
                        source: suggestion.source,
                        type: row.category
                      });
                    }
                  });
                  accu = accu.concat(suggestionRows);
                  return accu;
                }, []);
                setSuggestions(reformatedSuggestions);
              }
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
    // Note: cleanup function runs before the effect is re-executed.
    return function () {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term]);

  //to be removed when im-theme is in place
  var listBoxProps = {
    onMouseEnter: function onMouseEnter() {
      return setMouseInListBox(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setMouseInListBox(false);
    },
    sx: {
      '& .MuiAutocomplete-groupLabel': {
        backgroundColor: '#F8F8F8',
        borderBottom: 1,
        borderBottomColor: '#E0E0E0',
        display: enableAISuggestions ? 'none' : 'block'
      },
      '& .MuiAutocomplete-groupUl': {
        '&::-webkit-scrollbar': {
          width: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundClip: 'padding-box',
          backgroundColor: '#bdbdbd',
          border: '4px solid rgba(0, 0, 0, 0)'
        },
        maxHeight: '108px',
        overflowX: 'hidden',
        overflowY: 'overlay'
      },
      '& .MuiAutocomplete-groupUl .MuiAutocomplete-option': {
        paddingLeft: '16px'
      },
      '& .MuiAutocomplete-option.Mui-focused': {
        backgroundColor: !mouseInListBox ? '#fff' : '#F7F7F7'
      },
      'li:first-child': {
        '& .MuiAutocomplete-groupUl': {
          maxHeight: enableAISuggestions ? '500px' : '288px'
        }
      },
      maxHeight: '692px',
      p: 0
    }
  };
  return /*#__PURE__*/_jsx(StyledAutocomplete, {
    ListboxProps: listBoxProps,
    disableClearable: true,
    filterOptions: function filterOptions(options) {
      return options;
    },
    freeSolo: true,
    fullWidth: true,
    getOptionLabel: function getOptionLabel(option) {
      return typeof option === 'string' ? option : option.option;
    },
    groupBy: function groupBy(option) {
      return option.type;
    },
    inputValue: inputValue,
    onChange: onChange,
    onInputChange: onInputChange,
    onKeyDownCapture: function onKeyDownCapture(e) {
      if (e.key === 'Enter' && !mouseInListBox) {
        e.stopPropagation();
        e.target.blur();
        handleSearch('Enter');
      }
    },
    options: suggestions,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_jsx(TextField, _extends({
        className: "searchText",
        "data-testid": "".concat(testid, "-SearchText")
      }, params, {
        InputProps: _extends({}, params.InputProps, {
          endAdornment: /*#__PURE__*/_jsx(IconButton, {
            "aria-label": translate('Dashboard.Delete'),
            "data-name": "search_delete",
            onClick: onClose,
            sx: {
              marginRight: '8px',
              padding: 0,
              visibility: inputValue ? 'visible' : 'hidden'
            },
            children: _CloseIcon || (_CloseIcon = /*#__PURE__*/_jsx(CloseIcon, {}))
          }),
          startAdornment: /*#__PURE__*/_jsx(InputAdornment, {
            position: "start",
            children: /*#__PURE__*/_jsx(IconButton, {
              "aria-label": translate('Common.Search'),
              onClick: function onClick() {
                return handleSearch('searchIcon');
              },
              sx: {
                marginLeft: '4px',
                marginRight: '8px',
                padding: 0
              },
              children: /*#__PURE__*/_jsx(SearchIcon, {
                "data-testid": "".concat(testid, "-SearchIcon")
              })
            })
          })
        }),
        onKeyPress: onKeyPress,
        placeholder: translate('Product.Searchplaceholder')
      }));
    },
    renderOption: function renderOption(props, option, _ref5) {
      var inputValue = _ref5.inputValue;
      var matches = match(option.option, inputValue, {
        insideWords: true
      });
      var parts = parse(option.option, matches);
      var isCloud = option.isCloud;
      return /*#__PURE__*/_jsx("li", _extends({}, props, {
        children: /*#__PURE__*/_jsx("div", {
          style: {
            width: '100%'
          },
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              justifyContent: 'space-between'
            },
            children: [/*#__PURE__*/_jsx(Box, {
              children: parts.map(function (part, index) {
                return /*#__PURE__*/_jsx(Typography, {
                  component: 'span',
                  sx: {
                    fontWeight: part.highlight ? 400 : 'bold'
                  },
                  children: part.text
                }, index);
              })
            }), isCloud && (_CloudTwoToneIcon || (_CloudTwoToneIcon = /*#__PURE__*/_jsx(CloudTwoToneIcon, {
              color: "primary",
              fontSize: "small"
            })))]
          })
        })
      }));
    },
    selectOnFocus: true,
    "data-element": "StyledAutocomplete",
    "data-component": "SearchTypeAhead",
    "data-source-file": "SearchTypeAhead.tsx"
  });
}
var StyledAutocomplete = styled(Autocomplete)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    '& .MuiDivider-root': {
      alignSelf: 'center',
      height: 24
    },
    '& .MuiSvgIcon-root': {
      fontSize: '24px'
    },
    '& .MuiTextField-root .MuiInputAdornment-root': {
      '& .MuiSvgIcon-root': {
        height: '24px',
        width: '24px'
      },
      margin: 0
    },
    '& .micIcon': {
      padding: '8.5px 7px'
    },
    '& .searchText': {
      '& .MuiOutlinedInput-input': {
        color: theme.palette.grey[600],
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px',
        padding: 0
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '4px',
        flexWrap: 'nowrap',
        height: '32px',
        marginTop: 0
      }
    },
    '& .uploadImg': {
      paddingBottom: 8.5,
      paddingLeft: 4,
      paddingRight: 7,
      paddingTop: 8.5
    },
    height: '32px',
    width: '100%'
  };
});